import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

export function AppLoadingScreen() {
  const [timedOut, setTimedOut] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => setTimedOut(true), 8000);
    return () => clearTimeout(timer);
  }, []);

  const handleRedirect = () => {
    // Force a clean redirect to auth
    window.location.replace("/auth");
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center relative overflow-hidden">
      {/* Subtle ambient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-accent/5" />
      
      {/* Centered content */}
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.4, ease: "easeOut" }}
        className="relative z-10 flex flex-col items-center gap-8"
      >
        {/* Sorvaine Logo with glow */}
        <div className="relative">
          <motion.img
            src="/icon.png"
            alt="Sorvaine"
            className="h-16 w-auto"
            animate={{ opacity: [0.7, 1, 0.7] }}
            transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
          />
          {/* Subtle glow behind */}
          <div className="absolute inset-0 blur-2xl bg-primary/20 -z-10 scale-150" />
        </div>

        {timedOut ? (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="flex flex-col items-center gap-3"
          >
            <p className="text-sm text-muted-foreground font-mono tracking-wide">
              Session could not be restored.
            </p>
            <button
              onClick={handleRedirect}
              className="text-sm text-primary hover:underline font-medium"
            >
              Return to sign in
            </button>
          </motion.div>
        ) : (
          <>
            {/* Animated loading dots */}
            <div className="flex items-center gap-2">
              {[0, 1, 2].map((i) => (
                <motion.div
                  key={i}
                  className="w-2 h-2 rounded-full bg-primary/60"
                  animate={{
                    scale: [1, 1.3, 1],
                    opacity: [0.4, 1, 0.4],
                  }}
                  transition={{
                    duration: 1,
                    repeat: Infinity,
                    delay: i * 0.2,
                    ease: "easeInOut",
                  }}
                />
              ))}
            </div>

            {/* Status text */}
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.3, duration: 0.4 }}
              className="text-sm text-muted-foreground font-mono tracking-wide"
            >
              Initializing secure session...
            </motion.p>
          </>
        )}
      </motion.div>
    </div>
  );
}
